import React from 'react'

import { classes } from '../utils'

type Props = {
  /** Error message */
  message: string
  /** External className */
  className?: string
} & React.HtmlHTMLAttributes<HTMLDivElement>

/** Renders an error message on forms */
const InputError = ({ message, className, ...other }: Props) => {
  return (
    <div
      className={classes('mt-1.5 text-xs text-red-500', className)}
      {...other}
    >
      {message}
    </div>
  )
}

export default InputError
